const adobeConfig =
  typeof window !== "undefined"
    ? window?.app_data?.appcmsMain?.analytics?.adobeConfig
    : {};

const VISITOR = {
    MARKETING_CLOUD_ORG_ID: adobeConfig?.orgId,
    TRACKING_SERVER: adobeConfig?.trackingServer,
    ANALYTICS_TRACKING_SERVER: "os.fandango.com",
}
const APP_MEASUREMENT = {
    RSID: adobeConfig?.rsid,
}

export { VISITOR, APP_MEASUREMENT }